import { render, staticRenderFns } from "./Millage.vue?vue&type=template&id=8ec82f64&"
import script from "./Millage.vue?vue&type=script&lang=js&"
export * from "./Millage.vue?vue&type=script&lang=js&"
import style0 from "./Millage.vue?vue&type=style&index=0&id=8ec82f64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports